const inputs = [
  document.getElementById('js-simulation-price'),
  document.getElementById('js-simulation-capacity'),
  document.getElementById('js-simulation-days'),
  document.getElementById('js-simulation-fryers'),
  document.getElementById('js-simulation-stores'),
];
const result = document.getElementById('js-simulation-result');

if (inputs.every(el => el) && result) {
  const calculate = () => {
    const price    = parseFloat(inputs[0].value);
    const capacity = parseFloat(inputs[1].value);
    const days     = parseFloat(inputs[2].value);
    const fryers   = parseFloat(inputs[3].value);
    const stores   = parseFloat(inputs[4].value);

    if ([price, capacity, days, fryers, stores].some(v => isNaN(v) || v <= 0)) {
      result.textContent = '';
      return;
    }

    const amount = (price * capacity * 365 / days / 2 - capacity * 7.5 * 365) * fryers * stores;
    result.textContent = amount < 0 ? 'ー' : Math.round(amount).toLocaleString('ja-JP');
  };

  inputs.forEach(input => {
    input.addEventListener('input', () => {
      const max = parseInt(input.getAttribute('max'), 10);
      if (input.value.length > String(max).length) {
        input.value = input.value.slice(0, String(max).length);
      }
      calculate();
    });
  });
}


